import { render, staticRenderFns } from "./OtherUser.vue?vue&type=template&id=dc5d0808&scoped=true&"
import script from "./OtherUser.vue?vue&type=script&lang=js&"
export * from "./OtherUser.vue?vue&type=script&lang=js&"
import style0 from "./OtherUser.vue?vue&type=style&index=0&id=dc5d0808&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5d0808",
  null
  
)

export default component.exports